import { create } from "zustand";
import type { GpsDevice } from "../types";

interface GpsDevicesState {
	modalOpen: boolean;
	editingDevice: GpsDevice | null;
}

interface GpsDevicesActions {
	openCreateModal: () => void;
	openEditModal: (device: GpsDevice) => void;
	closeModal: () => void;
}

type GpsDevicesStore = GpsDevicesState & GpsDevicesActions;

export const useGpsDevicesStore = create<GpsDevicesStore>((set) => ({
	modalOpen: false,
	editingDevice: null,

	openCreateModal: () => {
		set({ modalOpen: true, editingDevice: null });
	},

	openEditModal: (device) => {
		set({ modalOpen: true, editingDevice: device });
	},

	closeModal: () => {
		set({ modalOpen: false, editingDevice: null });
	},
}));
